<template>
  <div>
     <Table :columns="columns10" :data="data9"> </Table>
     <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page
              :total="total"
              :page-size="30"
              :current="current"
              @on-change="changePage"
            ></Page>
          </div>
        </div>
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import {
  cmsWaringList,
  cmsCleanWaring,
  updateMachineStatus,
  waringReply
} from "../../api/machine";
 
 
export default {
  components: { SingleUpload },
  data() {
    return {
      machineNumber: "",
      modal3: false,
      jiqitype: "3",
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      jiqihao: "", //机器号
      duankouhao: "", //端口号
      roomname: "", //房间名称
      danjia: "", //单价
      jiangli: "", //奖励
      progress: "10", //询奖时间
      loading: true,
      modal1: false,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      timer: null,
      columns10: [
        {
          title: "房间名称",
          key: "roomname",
        },
         
        {
          title: "备注",
          key: "remarks",
        },
        {
          title: "机器状态",
          key: "status",
          render: (h, params) => {
            const status = params.row.status;
            return h(
              "span",
              status === 0 ? "关机" : status === 1 ? "开机" : "维护"
            );
          },
        },
        {
          title: "错误类型",
          key: "ntype",
          render: (h, params) => {
            const status = params.row.ntype;
            return h(
              "span",
              status === 0 ? "玩家上报" : "机器识别"
            );
          },
        },
        {
          
          title: "是否回复",
          key: "reply",
          render: (h, params) => {
            const status = params.row.reply;
            return h(
              "span",
              status === 1 ? "未回复" : status === 2 ? "等会" : "别等了"
            );
          },
        },
        {
          title: "上报时间",
          key: "createtime",
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          render: (h, params) => {
            return h("div", [
             (params.row.status === 2 && (params.row.machinetype === 3 || params.row.machinetype === 4))
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.machineNumber = params.row.machineid;
                          this.updateMachineStatus(1);
                          this.updateimage2(params.row.id);
                        },
                      },
                    },
                    "开机"
                  )
                :   h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.updateimage2(params.row.id);
                    },
                  },
                },
                "清除"
              ),
               
              //娃娃机暂时去掉维护
              (params.row.status === 1 && (params.row.machinetype === 3 || params.row.machinetype === 4) && params.row.reply == 1)
              ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.machineNumber = params.row.machineid;
                          this.waringReply(params.row.id,2);
                          this.updateMachineStatus(2 );
                        },
                      },
                    },
                    "先维护修一会"
                  )
                : null,
               //娃娃机暂时去掉维护
               (params.row.status === 1 && (params.row.machinetype === 3 || params.row.machinetype === 4) && params.row.reply == 1)
               ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.machineNumber = params.row.machineid;
                          this.waringReply(params.row.id,3);
                          this.updateMachineStatus(2);
                        },
                      },
                    },
                    "别等了,修半天"
                  )
                : null, 
            
            ]);
          },
        },
      ],
      current: 1,
      total: 0,
      data9: [],
    };
  },
  mounted() {
    this.selmachine();
    // Set up timer to call selmachine every 2 seconds
    this.timer = setInterval(() => {
      console.log("===");
      this.selmachine();
    }, 5000);
  },
  beforeDestroy() {
    // Clean up timer when component is destroyed
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    changePage(e) {
      this.current = e;
      this.selmachine(); // 直接调用查询函数，不用重复逻辑
    },
    selmachine() {
      console.log("===");

      cmsWaringList({  page: this.current}).then((response) => {
        console.log("===" + JSON.stringify(response));
        this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
      });
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(id) {
      
      cmsCleanWaring({
         cid: id,
      }).then((res) => {
        this.selmachine();
      });
    },
    ok() {
      cerCoinMachine({
        machineid: this.jiqihao,
        roomname: this.roomname,
        roomlv: this.roomlv,
        image: this.fengmian,
        rule: this.guize,
        price: this.danjia,
        reward: this.jiangli,
        progress: parseInt(this.progress),
        videourl1: this.videourl1,
        machinetype: this.jiqitype === "3" ? 3 : 4,
        sort: 0,
      })
        .then((res) => {
          this.modal1 = false;
          this.$Message.info("Clicked ok");
        })
        .catch((err) => {});
      //
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    waringReply(cid,reply){
 
      waringReply({
        cid: cid,
        reply:reply
      }).then((res) => {
      });
 
    },
    updateMachineStatus(status) {
     
      updateMachineStatus({
        status: status,
        roomid: this.clickmachineid,
        machineNumber: this.machineNumber,
      }).then((res) => {
        this.selmachine();
      });
    },
    guanbimodal() {
      this.modal3 = false;
    },
  },
};
</script>
